function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
export function cloneDeep(obj) {
  var pull = new Map();
  var clone = cloneDeepMaster(obj);
  pull.clear();
  return clone;
  function cloneDeepMaster(obj) {
    if (_typeof(obj) !== 'object' || obj === null) {
      return obj;
    }
    if (obj instanceof Array) {
      var _clone = [];
      pull.set(obj, _clone);
      for (var i = 0; i < obj.length; i++) {
        if (pull.has(obj[i])) {
          _clone.push(pull.get(obj[i]));
        } else {
          _clone.push(cloneDeepMaster(obj[i]));
        }
      }
      return _clone;
    }
    var clone = {};
    pull.set(obj, clone);
    for (var key in obj) {
      if (pull.has(obj[key])) {
        clone[key] = pull.get(obj[key]);
      } else {
        clone[key] = cloneDeepMaster(obj[key]);
      }
    }
    return clone;
  }
}